export * from './rx_authorization_control_directive';
